/**
 * temporary half finished class to handle locations in the framework
 * Locations will be moved into the framework in the backend, too.
 */
export class LicenceInfo {
  type: string;
  assigned: number;
  available: number;
  open: number;
  assignable: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.type = payload.type;
      this.assigned = payload.assigned;
      this.available = payload.available;
      this.open = payload.open;
      this.assignable = payload.assignable;
    }
  }

  /**
   * creates locations from a result
   * @param result Array of any
   * @returns Array of Location
   */
   static createLicenceInfos(result: Array<any>): LicenceInfo[] {
    const liceInfos = new Array<LicenceInfo>();
    if (result) {
      result.map((licenceInfo) => {
        liceInfos.push(new LicenceInfo(licenceInfo));
      });
    }
    return liceInfos;
  }
}